import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, ValidationError } from "@formspree/react";

export const GetInTouch = () => {
  const [state, handleSubmit] = useForm("xkgbypeq");
  const navigate = useNavigate();
  useEffect(() => {
    if (state.succeeded) {
      document.body.style.overflow = "hidden";
      const timeout = setTimeout(() => {
        document.body.style.overflow = "auto";
        navigate("/");
      }, 2000);
      return () => {
        document.body.style.overflow = "auto";
        clearTimeout(timeout); // limpia el timeout si cambia el estado
      };
    }
  }, [state.succeeded, navigate]);

  if (state.succeeded)
    return (
      <div className="full-coverage">
        <img
          src="https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/183.gif"
          className="img-redirect"
          alt="rosario"
          title="dos"
        />
        <h2 className="txt-succes">✅ Your message was sent successfully!</h2>
        <p className="ph-succes">We'll redirect you in a moment ...</p>
      </div>
    );

  return (
    <div id="contact-form-container">
      <p className="form-title">Get in touch!</p>
      {/* <form className="form-contact">
        <div className="form-grup">
          <label for="name">Name:</label>
          <input
            className="input-style trans"
            type="text"
            id="name"
            name="name"
            required
          />
        </div>

        <div className="form-grup">
          <label for="email">e-mail:</label>
          <input
            className="input-style trans"
            type="email"
            id="email"
            name="email"
            required
          />
        </div>

        <div className="form-grup">
          <label for="message">Message</label>
          <textarea
            className="input-style"
            id="message"
            name="message"
            required
          />
        </div>
        <ButtonRectangle
          complementaryText={"Pika Pika"}
          newColorButton={"rgb(101, 125, 241) "}
        />
      </form> */}

      <form className="form-contacto-section" onSubmit={handleSubmit}>
        <div className="form-grup">
          <label htmlFor="name">Name:</label>
          <input
            id="name"
            type="text"
            name="name"
            required
            placeholder="Ej. Anna Oh"
            className="input-style trans"
          />
          <ValidationError prefix="Nombre" field="name" errors={state.errors} />
        </div>
        <div className="form-grup">
          <label htmlFor="name">Favorite Pokemon:</label>
          <input
            id="pokemon"
            type="text"
            name="pokemon"
            required
            placeholder="Ej. Jigglypuff"
            className="input-style trans"
          />
          <ValidationError
            prefix="Pokemon"
            field="pokemon"
            errors={state.errors}
          />
        </div>

        <div className="form-grup">
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="email"
            name="email"
            required
            placeholder="ejemplo@gmail.com"
            className="input-style trans"
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>

        <div className="form-grup form-grup-area">
          <label htmlFor="message">Message</label>
          <textarea
            required
            placeholder="Write your message here..."
            id="message"
            name="message"
            className="input-style"
          />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>
        <button
          style={{ backgroundColor: "rgb(101, 125, 241)", color: "white" }}
          className="button-rectangle"
          type="submit"
          disabled={state.submitting}
        >
          {state.submitting ? "Sending..." : "Pika Pika!"}
        </button>
      </form>
    </div>
  );
};

export default GetInTouch;
